import { lazy } from "react";
import WithSuspense from "../components/loader/WithSuspense";
import { PATHS } from "./constants";

const { HOME, SERVICES, CONTACT, CAREER, ABOUT } = PATHS;

const Home = WithSuspense(lazy(() => import("../pages/Home")));
const Services = WithSuspense(lazy(() => import("../pages/Services")));
const AboutUs = WithSuspense(lazy(() => import("../pages/AboutUs")));
const Career = WithSuspense(lazy(() => import("../pages/Career")));
const Contact = WithSuspense(lazy(() => import("../pages/Contact")));
const PortalLogin = WithSuspense(lazy(() => import("../pages/PortalLogin")));
const Privacy = WithSuspense(lazy(() => import("../pages/Privacy")));
const Terms = WithSuspense(lazy(() => import("../pages/Terms")));
const Compliance = WithSuspense(lazy(() => import("../pages/Compliance")));
const NotFound = WithSuspense(lazy(() => import("../pages/NotFound")));

export const ROUTES = [
  { path: HOME, element: <Home /> },
  { path: SERVICES, element: <Services /> },
  { path: CAREER, element: <Career /> },
  { path: CONTACT, element: <Contact /> },
  { path: ABOUT, element: <AboutUs /> },
  { path: "/portal/login", element: <PortalLogin /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/terms", element: <Terms /> },
  { path: "/compliance", element: <Compliance /> },
  { path: "*", element: <NotFound /> },
];
